var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3274",
    "data-name": "Rectangle 3274",
    width: 22,
    height: 22,
    transform: "translate(-2.38 -2)",
    fill: "#5a5a5a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11073",
    "data-name": "Group 11073",
    transform: "translate(2.38 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11072",
    "data-name": "Group 11072",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29024",
    "data-name": "Path 29024",
    d: "M7.648,6a.85.85,0,0,0-.9.9V11.39a.85.85,0,0,0,.9.9.85.85,0,0,0,.9-.9V6.9a.85.85,0,0,0-.9-.9",
    transform: "translate(1.335 1.187)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29025",
    "data-name": "Path 29025",
    d: "M8.547,4.648a.9.9,0,1,1-.9-.9.9.9,0,0,1,.9.9",
    transform: "translate(1.335 0.742)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29026",
    "data-name": "Path 29026",
    d: "M8.983,0a8.983,8.983,0,1,0,8.983,8.983A9.01,9.01,0,0,0,8.983,0m0,16.17A7.187,7.187,0,1,1,16.17,8.983,7.206,7.206,0,0,1,8.983,16.17",
    fill: "#5a5a5a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.ea766e8c40d0b23c46fce230d5b28bae.svg";
export { ForwardRef as ReactComponent };